import {showErrorMessage, showSuccessMessage} from '@/helper';

export default {
    fetchRecords(clientId, body) {
        return new Promise((resolve, reject) => {
            http.post(`api/clients/${clientId}/identifications/list`, {
                page: body.page,
                search: body.search,
                length: body.pageLength,
                order: [{'column': body.orderColumn, 'dir': body.orderAsc ? 'asc' : 'desc'}],
                filter: body.filter
            }).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    get(clientId, recordId) {
        return new Promise((resolve, reject) => {
            http.get(`api/clients/${clientId}/identifications/${recordId}`).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    saveIdentification(clientId, data) {
        const formData = new FormData();
        Object.entries(data).forEach(([key, value]) => {
            if (key === 'attachments') {
                value.forEach(file => {
                    formData.append('attachments[]', file);
                });
            } else if (key === 'data') {
                formData.append(key, JSON.stringify(value));
            }
            else {
                formData.append(key, value);
            }
        });

        return new Promise((resolve, reject) => {
            http.post('api/clients/' + clientId + '/identifications' + (data.id ? '/' + data.id : ''), data, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }).then(response => {
                resolve(response.data);
            }).catch(error => {
                if (error.response?.data?.message) {
                    showErrorMessage(error.response.data.message);
                }
                reject(error.response.data);
            });
        });
    },

    deleteRecord(clientId, recordId) {
        return new Promise((resolve, reject) => {
            http.delete('api/clients/' + clientId + '/identifications/' + recordId).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    saveWithBankID(clientId, recordId, bankIdCode) {
        return new Promise((resolve, reject) => {
            http.post(`api/clients/${clientId}/identifications/${recordId}/save-with-bank-id`, {code: bankIdCode}).then(response => {
                localStorage.removeItem('IDENTIFICATION_ID');
                showSuccessMessage('Identifikace byla úspěšně dokončena');
                window.location.href = 'home';
                resolve(response.data);
            }).catch(error => {
                localStorage.removeItem('IDENTIFICATION_ID');
                window.location.href = 'home';
                reject(error.response.data);
            });
        });
    }
}
